/**
 * Compute next greater viewLevel
 * @param viewLevelResult
 * @returns
 */
export function computeNextViewLevel(viewLevelResult) {
    const { requiredViewLevel, viewLevels } = viewLevelResult;
    // sort so we can determined the next greater
    const viewLevelItems = Array.from(viewLevels).sort((a, b) => a - b);
    // determine the next greater viewLevel
    const foundViewLevel = viewLevelItems.find((value) => value >= requiredViewLevel);
    // if none is found, use maximum number
    return foundViewLevel !== null && foundViewLevel !== void 0 ? foundViewLevel : Number.MAX_SAFE_INTEGER;
}
//# sourceMappingURL=computeNextViewLevel.js.map